import { render, staticRenderFns } from "./LightFinal.vue?vue&type=template&id=78d79fd0&scoped=true&"
import script from "./LightFinal.vue?vue&type=script&lang=js&"
export * from "./LightFinal.vue?vue&type=script&lang=js&"
import style0 from "./LightFinal.vue?vue&type=style&index=0&id=78d79fd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d79fd0",
  null
  
)

export default component.exports